/**
 * 获取支付方式工具类
 *
 * @author terrfly
 * @site https://www.jeepay.vip
 * @date 2021/5/8 07:18
 */

import config from '@/config'

const getToPageRouteName = function () {
    const payWay = getPayWay();
    return  payWay? payWay.routeName : null
}

const getPayWay = function () {

    const userAgent = navigator.userAgent;

    if(userAgent.indexOf("MicroMessenger") >= 0){
        return config.payWay.WXPAY;
    }

    if(userAgent.indexOf("AlipayClient") >= 0){
        return config.payWay.ALIPAY;
    }
     // 2. 核心特征检测（UnionPay/UPBrowser 二选一即可，双重检测更稳定）
    const isUnionPay = userAgent.toLowerCase().includes('unionpay') || userAgent.includes('upbrowser');
  
    // 3. 排除干扰：避免把其他含 UnionPay 字符的浏览器误判（如部分安卓手机自带浏览器）
    // 补充检测：云闪付 UA 通常不含微信/支付宝/QQ 等特征
    const isOtherEnv = userAgent.toLowerCase().includes('micromessenger') // 微信
                    || userAgent.toLowerCase().includes('alipay') // 支付宝
                    || userAgent.toLowerCase().includes('qqbrowser') // QQ浏览器
                    || userAgent.toLowerCase().includes('ucbrowser'); // UC浏览器
    if (isUnionPay && !isOtherEnv) {
        return config.payWay.YSFPAY;
    }
    return config.payWay.H5;

}


export default { getToPageRouteName: getToPageRouteName,
    getPayWay: getPayWay

}
